import React from "react";
import { useDispatch } from "react-redux";
import SocialLogo from "../../components/SocialLogo";
import { getImgUrl } from "../../utils/helper";
import { setSelectedId } from "../modal/modalSlice";

const Profiles = ({ filteredUsers, page }) => {
  const dispatch = useDispatch();

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-3 gap-10 md:m-10">
      {filteredUsers.slice(0, page * 20).map((profile) => (
        <div
          key={profile.id}
          className="bg-white rounded-sm border border-slate-200 shadow-lg shadow-slate-300/30 w-full"
        >
          <div className="flex flex-col h-full">
            <div className="p-[1.25rem] flex-grow">
              <div className="relative">
                <header>
                  <div className="flex justify-center mb-[0.5rem]">
                    <div className="rounded-full overflow-hidden ring ring-primary ring-offset-base-100 ring-offset-2 relative">
                      <img
                        src={getImgUrl(profile)}
                        width="80"
                        height="80"
                        alt={profile.name}
                        className=" object-cover h-20"
                        loading="lazy"
                      />
                    </div>
                  </div>
                  <div className="flex justify-center items-center min-h-[2rem]">
                    {profile.socialNetworks.map((social, i) => (
                      <SocialLogo url={social} key={i} size={20} />
                    ))}
                  </div>
                  <div className="text-center">
                    <h2 className="text-slate-800 leading-[1.375] font-bold">
                      {profile.Name}
                    </h2>
                  </div>
                </header>
                <div className="text-center">
                  <div className="text-sm text-gray-500">
                    {profile.Specialty ? profile.Specialty : profile.Sector}
                  </div>
                </div>
              </div>
            </div>
            <div className="border-t border-slate-200">
              <div className="flex w-full flex-row">
                <button
                  onClick={() => dispatch(setSelectedId(profile.id))}
                  className="block ac text-center text-sm text-indigo-500  px-3 py-3 w-full  hover:bg-indigo-500 hover:text-white transition-all duration-300"
                >
                  <div className="flex items-center justify-center">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="w-6 h-6 flex-shrink mr-2"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      strokeWidth="2"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z"
                      />
                    </svg>
                    <span>Profile</span>
                  </div>
                </button>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Profiles;
